/**
 * Clipboard helper — modern browsers only (spec.md § Editor / Clipboard:
 * "modern browsers only (navigator.clipboard.writeText); no document.execCommand
 * fallback"). Last-1-evergreen browser support is a hard convention.
 *
 * Throws an Error (never a string — AGENTS.md) when the API is unavailable or
 * the write is rejected so callers can surface a toast.
 */
export async function copyToClipboard(text: string): Promise<void> {
  if (
    typeof navigator === "undefined" ||
    !navigator.clipboard ||
    typeof navigator.clipboard.writeText !== "function"
  ) {
    throw new Error("Clipboard API unavailable");
  }
  await navigator.clipboard.writeText(text);
}
